import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ConvertImagePipe } from './pipe/convert-image-pipe';
import { ReplaceText } from './pipe/replace-text-pipe';
import { TruncateCharactersPipe } from './pipe/truncate-characters.pipe';
import { ValuesPipe } from './pipe/values-pipe';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

@NgModule({
  imports: [
    CommonModule,
    InfiniteScrollModule,

  ],
  declarations: [ConvertImagePipe, ReplaceText, TruncateCharactersPipe, ValuesPipe],
  exports: [InfiniteScrollModule,
    CommonModule, FormsModule, TranslateModule, ConvertImagePipe, ReplaceText, TruncateCharactersPipe, ValuesPipe]
})
export class SharedModule { }
